import script from "./ColumnFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColumnFilter.vue?vue&type=script&setup=true&lang=ts"

import "./ColumnFilter.vue?vue&type=style&index=0&id=2bb93d5f&lang=scss&scoped=true"

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb93d5f"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
